import React from 'react';
import { Icon } from '@saviynt/design-system';

import { LoaderResponse, SaviDataResponse } from '../../../components';
import { type SaviMessage } from '../../../context';

import './SaviResponse.css';

interface SaviResponseProps {
  message?: SaviMessage;
}

SaviResponse.defaultProps = {
  message: null,
};

export default function SaviResponse({ message }: SaviResponseProps) {
  function getServerMessageNodes() {
    if (!message) {
      return <LoaderResponse />;
    }

    return <SaviDataResponse data={message.data} />;
  }

  return (
    <div className='Ispm-SaviResponse'>
      <Icon kind='SaviCompanion' className='Ispm-SaviResponse-Icon' />
      <div data-testid='saviResponseTest' className='Ispm-SaviResponse-Content'>
        {getServerMessageNodes()}
      </div>
    </div>
  );
}
